import API from '@/API/API'

const EditListingStore = {
  api: API,
  state: {
    currentUserId: '',
    listingId:'',
    listing:[],
    selectedService:{},
    loading:false
  },
  reset: function() {
    this.state = {
      currentUserId: '',
      listingId:'',
      listing:[],
      selectedService:{},
      loading:false
    }
  },
  getThreeMonthTrial: function(){
    let self = this;
    this.api
    .getThreeMonthTrial()
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (!data.error) {
            if(data.maintenanceMode){
              return
            }
            self.state.threeMonthTrial = data.threeMonthTrial
        }
      }else{
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  getListing: function(success,error,maintenance){
    let self = this;
    this.api
    .getListing(this.state.currentUserId, this.state.listingId)
    .then(function (res) {
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            data.listing.didChangePhoto = false
            self.state.listing = data.listing
            success()
        }
      }else{
          error("Failed to get listing");
      }
    })
    .catch(e => {
      error('An Error Occurred')
    })
  },
  updateListing: function(success,error,maintenance) {
    this.state.loading = true
    let self = this;

    var textColor = this.state.listing.textColor;
    if(typeof textColor !== 'string') {
      textColor = textColor.hex
    }

    var backgroundColor = this.state.listing.backgroundColor;
    if(typeof backgroundColor !== 'string') {
      backgroundColor = backgroundColor.hex
    }

    this.state.listing.tColor = textColor
    this.state.listing.bgColor = backgroundColor

    this.api
    .updateListing(this.state.listing)
    .then(function (res) {
      self.state.loading = false
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            success()
        }
      }else{
          error("Failed to save listing");
      }
    })
    .catch(e => {
      self.state.loading = false
      error('An Error Occurred')
    })
  },
  validate: function(){
    var err = null
    this.state.listing.fields.forEach(field => {
      if(field.required == 1){
        let value = field.value
        if(value == '' || !value){
          err = field.fieldName + ' is a required field';
          return;
        }
      }

      if(field.characterLimit > 0) {
        let value = field.value
        if(value.length > field.characterLimit) {
          err = `${field.fieldName} must be less than ${field.characterLimit} characters`
          return;
        }
      }

    });

    if(this.state.listing.city == '') {
      err = 'City is a required field'
      return err;
    }

    if(this.state.listing.state == '') {
      err = 'State is a required field'
      return err;
    }

    return err;
  },
}

export default EditListingStore



// WEBPACK FOOTER //
// ./src/components/account/EditListingStore.js